import { buildsServiceApi } from "../../api";

export interface IUpdateObject {
  // PART - без адреса
  type: "PART" | "FULL";
  buildingObjectId: string;
  updateBuildingObjectRequest: {
    shortName: string;
    fullName: string;
    descriptionProjects: string;
    descriptionStage: string;
    constructionType: "CONSTRUCTION" | "RECONSTRUCTION" | "RENOVATION";
    buildingStart: string;
    buildingEnd: string;
    address?: {
      // TODO ENUM
      addressType: string;
      addressString: string;
      countryId: number;
      regionId: number;
      districtName: string;
      districtCode: string;
    };
  };
  documentationPermissions: {
    documentationPermissionId: string | null;
    number: string;
    date: string;
    issued: string;
    expiryDate: string;
    prolongDate: string;
    permissionFile: {
      file: {
        key: string | null;
        fileName: string;
        fileType: string;
        fileContentLength: number;
      } | null;
      signature: {
        key: string | null;
        fileName: string;
        fileType: string;
        fileContentLength: number;
      } | null;
    };
  }[];
  documentationExaminations: {
    documentationExaminationId: string | null;
    number: string;
    date: string;
    issued: string;
    expiryDate: string;
    prolongDate: string;
    examinationFile: {
      file: {
        key: string | null;
        fileName: string;
        fileType: string;
        fileContentLength: number;
      } | null;
      signature: {
        key: string | null;
        fileName: string;
        fileType: string;
        fileContentLength: number;
      } | null;
    };
  }[];
  permissions: { uid: string; file: File }[];
  examinations: { uid: string; file: File }[];
}

export async function updateObject({
  type,
  buildingObjectId,
  updateBuildingObjectRequest,
  documentationPermissions,
  documentationExaminations,
  permissions,
  examinations,
}: IUpdateObject) {
  const formData = new FormData();
  formData.append(
    "updateBuildingObjectRequest",
    blobify(updateBuildingObjectRequest),
  );
  formData.append(
    "documentationPermissions",
    // todo
    blobify(documentationPermissions),
  );
  formData.append(
    "documentationExaminations",
    blobify(documentationExaminations),
  );

  permissions?.forEach((p) => formData.append(p.uid, p.file, p.file.name));

  examinations?.forEach((e) => formData.append(e.uid, e.file, e.file.name));

  const res = await buildsServiceApi.putForm(
    `building-objects/${type}/${buildingObjectId}`,
    formData,
  );

  return res.data;
}

function blobify(obj: object) {
  return new Blob([JSON.stringify(obj)], {
    type: "application/json",
  });
}
